import { CSSObject } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const scrollbarStyle: CSSObject = {
  '&::-webkit-scrollbar': {
    height: '8px',
    width: '8px',
    borderRadius: '10px',
    backgroundColor: `rgba(0, 0, 0, 0.15)`,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: `rgba(0, 0, 0, 0.15)`,
  },
}

export const Container = styled.div`
  height: 100%;
  .box {
    cursor: pointer;
  }
  .inBoxCorner {
    fill: #8ae8a6;
    stroke-width: 2px;
    stroke: #8ae8a6;
    cursor: grab;
  }
  .outBoxCorner {
    fill: #f9867d;
    stroke-width: 2px;
    stroke: #f9867d;
    cursor: grab;
  }
  .outBox-corner-group {
    cursor: grab;
  }
  .inBoxPath {
    stroke: #8ae8a6;
    stroke-width: 2px;
    fill: '#00A27A';
    fill-opacity: 0.21;
  }
  .outBoxPath {
    stroke: #f9867d;
    stroke-width: 2px;
    fill: #a20000;
    fill-opacity: 0.21;
  }
  .inBoxPath.inValidBox {
    stroke: #d2c866;
    fill: #d2c866;
  }
  .outBoxPath.inValidBox {
    stroke: #d2c866;
    fill: #d2c866;
  }
`
